import React from 'react';

// Helper function to format time
const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs.toString().padStart(2, '0')}`;
};

export function ProductModal({ show, currentProduct, isGameComplete, isLastProduct, onFindNext, onPlayAgain, buttonText, fromDecodedList, hasPendingNext, viewingDuringMatch, elapsedTime }) {
    if (!show) return null;
    
    // Only show congratulations card if game is complete AND not viewing from decoded list
    if (isGameComplete && !fromDecodedList) {
        return (
            <div className="modal show">
                <div className="modal-content">
                    <div className="modal-header">
                        <div className="product-found-icon">🎉</div>
                        <h2 className="product-title">Impressive!</h2>
                    </div>
                    <div className="modal-body" style={{ textAlign: 'center', padding: '20px' }}>
                        <h3 style={{ color: '#00ffff', marginBottom: '20px', fontSize: '24px',fontFamily:'Space Grotesk' }}>
                            You've discovered all 10 apps in <span style={{ fontSize: '32px', fontWeight: 'bold' }}>{elapsedTime > 0 ? formatTime(elapsedTime) : '0:00'}</span>
                        </h3>
                        <p style={{ color: 'rgba(255, 255, 255, 0.8)', lineHeight: '1.8', marginBottom: '15px',fontFamily:'Space Grotesk' }}>
                            Click any discovered app to revisit its updates, or restart to set a new best.
                        </p>
                        <p style={{ color: 'rgba(255, 255, 255, 0.8)', lineHeight: '1.8', fontFamily:'Space Grotesk' }}>
                            For the full 2025 Zoho Workplace roundup, continue reading the blog.
                        </p>
                    </div>
                    <button className="find-next-btn" onClick={onPlayAgain}>
                        Play Again
                    </button>
                </div>
            </div>
        );
    }
    
    if (!currentProduct) return null;
    
    // Button logic:
    // - If viewingDuringMatch is true: Show "Find next" (user clicked decoded product while match is pending)
    // - If NOT from decoded list: Show "Find next" (normal match flow)
    // - If from decoded list AND NOT viewingDuringMatch: Show "Close" (browsing decoded products, no pending match)
    const showFindNextButton = !fromDecodedList || viewingDuringMatch;
    
    return (
        <div className="modal show">
            <div className="modal-content">
                <div className="modal-header">
                    <div 
                        className="product-found-icon"
                        style={{
                            backgroundImage: `url('./images/SVG/${currentProduct.productIcon}.svg')`,
                            backgroundSize: 'contain',
                            backgroundPosition: 'center',
                            backgroundRepeat: 'no-repeat',
                            width: '40px',
                            height: '40px',
                            flexShrink: 0,
                            cursor: fromDecodedList && !hasPendingNext ? 'pointer' : undefined
                        }}
                        onClick={fromDecodedList && !hasPendingNext ? () => onFindNext() : undefined}
                    ></div>
                    <h2 className="product-title">{currentProduct.productName} FOUND!</h2>
                </div>
                <div className="modal-body">
                    <div className="updates-section" style={{ textAlign: 'center', marginBottom: '20px'}}>
                        <h3 className="updates-title">Key updates in 2025</h3>
                    </div>
                    <div className="feature-section">
                        <h3 className="feature-title">{currentProduct.features.title1}</h3>
                        <p className="feature-description">{currentProduct.features.description1}</p>
                    </div>
                    <div className="feature-section">
                        <h3 className="feature-title-2">{currentProduct.features.title2}</h3>
                        <p className="feature-description-2">{currentProduct.features.description2}</p>
                    </div>
                    {/* <div className="divider"></div>
                    {showFindNextButton && (
                        <div className="next-challenge">
                            <h3>What will you create next?</h3>
                        </div>
                    )} */}
                </div>
                {showFindNextButton ? (
                    <button className="find-next-btn" onClick={onFindNext}>
                        {buttonText || (isLastProduct ? 'Complete Game' : 'Find next')}
                    </button>
                ) : (
                    <button className="find-next-btn" onClick={onFindNext}>
                        Close
                    </button>
                )}
            </div>
        </div>
    );
}
